var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-page__tags"},_vm._l((_vm.manager.tags),function(ref,n){
var html = ref.html;
var style = ref.style;
return _c('div',{key:n,staticClass:"my-2 py-1 px-2 rounded",staticStyle:{"width":"fit-content"},style:(style),domProps:{"innerHTML":_vm._s(html)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }